<div class="box-info-container">
    @if (title != null && title != '') {
        <div class="box-info-title">
            <p>{{title}}</p>
        </div>
    }

    <div class="box-info-content">
        <ng-content></ng-content>
    </div>
</div>